import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { IconContainer } from "../IconContainer.mjs";
import { IconHelpSvg } from "./IconHelpSvg.mjs";
const IconHelp = (props) => /* @__PURE__ */ jsx(IconContainer, { ...props, children: (svgProps) => /* @__PURE__ */ jsx(Box, { component: IconHelpSvg, ...svgProps }) });
export {
  IconHelp
};
